var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading || _vm.error
    ? _c("div", { staticClass: "row justify-center items-center" }, [
        _c(
          "div",
          { staticClass: "col-auto" },
          [
            _vm.error
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("q-icon", {
                      attrs: { color: "negative", name: "info" }
                    }),
                    _vm._v("\n      Error occurred "),
                    _c("br"),
                    _c("q-btn", {
                      staticClass: "q-mt-xs",
                      attrs: { icon: "refresh", label: "Try again" },
                      on: {
                        click: function($event) {
                          _vm.init(true)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm.loading
              ? _c("q-spinner-puff", {
                  attrs: { color: "primary", size: "60px" }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _c(
        "div",
        { staticClass: "row gutter-sm" },
        [
          _c("bj-crud-form-modal", {
            ref: "crudModal",
            attrs: {
              fields: _vm.fields,
              "edit-fields": _vm.editFields,
              "date-fields": _vm.dateFields,
              model: "User",
              "endpoint-create": "admin/agents",
              "endpoint-edit": "users",
              callback: _vm.beforeSave,
              "not-crud": ""
            },
            on: { saved: _vm.onSave }
          }),
          _vm.sendNotificationModal.visible
            ? _c("send-notification-modal", {
                attrs: { "send-notification-modal": _vm.sendNotificationModal },
                on: {
                  close: function($event) {
                    _vm.sendNotificationModal.visible = false
                  }
                }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-card",
                [
                  _c("q-card-main", [
                    _c("div", { staticClass: "row gutter-md items-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-auto" },
                        [
                          _vm.agent.is_showami
                            ? _c(
                                "q-chip",
                                {
                                  staticClass: "font-weight-bold",
                                  staticStyle: {
                                    "font-size": "2rem",
                                    padding: "1rem"
                                  },
                                  attrs: {
                                    color: "orange",
                                    "text-color": "white"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Showami\n            "
                                  )
                                ]
                              )
                            : _c("img", {
                                staticClass: "float-left",
                                attrs: {
                                  id: "avatar",
                                  src: _vm.agent.avatar_file_url
                                }
                              })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "div",
                          {
                            staticClass: "q-mb-xs d-flex align-items-center",
                            attrs: { id: "full-name" }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.agent.full_name))]),
                            _c("span", { staticClass: "mx-3" }, [_vm._v("|")]),
                            _c("span", [_vm._v(_vm._s(_vm.agent.email))]),
                            _c("SdCopyToClipboard", {
                              staticClass: "ml-2",
                              attrs: { "with-icon": "", copy: _vm.agent.email }
                            }),
                            _c("span", { staticClass: "mx-3" }, [_vm._v("|")]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.agent.formatted_phone_number))
                            ]),
                            _c("SdCopyToClipboard", {
                              staticClass: "ml-2",
                              attrs: {
                                "with-icon": "",
                                copy: _vm.agent.phone_number
                              }
                            })
                          ],
                          1
                        ),
                        _c("span", [
                          _vm._v("System ID:" + _vm._s(_vm.agent.id))
                        ]),
                        _vm.agent.device
                          ? _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.agent.first_name) +
                                  " is using our App with " +
                                  _vm._s(_vm.agent.device.model) +
                                  " (version:" +
                                  _vm._s(_vm.agent.app_version) +
                                  ")\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm.agent.location
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://www.google.com/maps/search/?api=1&query=" +
                                    _vm.agent.location.coordinates[1] +
                                    "," +
                                    _vm.agent.location.coordinates[0],
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Click to open last known location\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.agent.location_updated_at
                          ? _c("div", [
                              _vm._v(
                                "\n              Location last updated at: " +
                                  _vm._s(
                                    _vm
                                      .moment(_vm.agent.location_updated_at)
                                      .tz(_vm.moment.tz.guess())
                                      .format("MM/DD/YY h:mmA")
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm.agent.used_app_at
                          ? _c("div", [
                              _vm._v(
                                "\n              Last used app at: " +
                                  _vm._s(
                                    _vm
                                      .moment(_vm.agent.used_app_at)
                                      .tz(_vm.moment.tz.guess())
                                      .format("MM/DD/YY h:mmA")
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _c("div", [
                          _vm._v(
                            "\n              Joined at " +
                              _vm._s(
                                _vm
                                  .moment(_vm.agent.created_at)
                                  .tz(_vm.moment.tz.guess())
                                  .format("MM/DD/YY h:mmA")
                              ) +
                              "\n            "
                          )
                        ]),
                        _c("div", { staticClass: "mt-2 mb-2" }, [
                          _vm._v(
                            "\n              Markets: " +
                              _vm._s(
                                _vm.agent.markets
                                  .map(function(market) {
                                    return market.name
                                  })
                                  .join(", ")
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm.agent.contact_status
                          ? _c("div", { staticClass: "mt-2 mb-2" }, [
                              _vm._v(
                                "\n              Greeting call: " +
                                  _vm._s(
                                    _vm.resolveContactStatus(
                                      _vm.agent.contact_status
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm.agent.contact_status_updated_at
                          ? _c("div", { staticClass: "mt-2 mb-2" }, [
                              _vm._v(
                                "\n              Greeting call updated at: " +
                                  _vm._s(
                                    _vm
                                      .moment(
                                        _vm.agent.contact_status_updated_at
                                      )
                                      .format("MM/DD/YY")
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2 mb-2",
                            class: _vm.agent.is_periodic_inspection_capable
                              ? "text-positive"
                              : "text-negative"
                          },
                          [
                            _c("q-icon", {
                              attrs: {
                                name: _vm.agent.is_periodic_inspection_capable
                                  ? "check"
                                  : "close"
                              }
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.agent.is_periodic_inspection_capable
                                    ? "Periodic inspections capable"
                                    : "Periodic inspections incapable"
                                ) +
                                "\n            "
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2 mb-2",
                            class: _vm.agent.is_mimo_inspection_capable
                              ? "text-positive"
                              : "text-negative"
                          },
                          [
                            _c("q-icon", {
                              attrs: {
                                name: _vm.agent.is_mimo_inspection_capable
                                  ? "check"
                                  : "close"
                              }
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.agent.is_mimo_inspection_capable
                                    ? "Move-in/Out inspections capable"
                                    : "Move-in/Out inspections incapable"
                                ) +
                                "\n            "
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2 mb-2",
                            class: _vm.agent.is_vacancy_check_inspection_capable
                              ? "text-positive"
                              : "text-negative"
                          },
                          [
                            _c("q-icon", {
                              attrs: {
                                name: _vm.agent
                                  .is_vacancy_check_inspection_capable
                                  ? "check"
                                  : "close"
                              }
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.agent.is_vacancy_check_inspection_capable
                                    ? "Vacancy check inspections capable"
                                    : "Vacancy check inspections incapable"
                                ) +
                                "\n            "
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2 mb-2",
                            class: _vm.agent.is_marketing_photos_capable
                              ? "text-positive"
                              : "text-negative"
                          },
                          [
                            _c("q-icon", {
                              attrs: {
                                name: _vm.agent.is_marketing_photos_capable
                                  ? "check"
                                  : "close"
                              }
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.agent.is_marketing_photos_capable
                                    ? "Marketing Photos capable"
                                    : "Marketing Photos capable incapable"
                                ) +
                                "\n            "
                            )
                          ],
                          1
                        ),
                        _vm.agent.is_tours_capable
                          ? _c(
                              "div",
                              { staticClass: "mt-2 mb-2 text-positive" },
                              [
                                _c("q-icon", { attrs: { name: "check" } }),
                                _vm._v(
                                  "\n              Tours - Capable\n            "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.agent.is_tours_experienced
                          ? _c(
                              "div",
                              { staticClass: "mt-2 mb-2 text-positive" },
                              [
                                _c("q-icon", { attrs: { name: "check" } }),
                                _vm._v(
                                  "\n              Tours - Experienced\n            "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.agent.is_inspections_experienced
                          ? _c(
                              "div",
                              { staticClass: "mt-2 mb-2 text-positive" },
                              [
                                _c("q-icon", { attrs: { name: "check" } }),
                                _vm._v(
                                  "\n              Inspections - Experienced\n            "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          [
                            _c("q-rating", {
                              attrs: { readonly: "" },
                              model: {
                                value: _vm.agent.rating,
                                callback: function($$v) {
                                  _vm.$set(_vm.agent, "rating", $$v)
                                },
                                expression: "agent.rating"
                              }
                            }),
                            _vm._v(
                              "\n              (" +
                                _vm._s(_vm.agent.reviews_count) +
                                " reviews)\n            "
                            )
                          ],
                          1
                        ),
                        _vm.agent.muted_until
                          ? _c(
                              "div",
                              { staticClass: "q-mt-sm" },
                              [
                                _c(
                                  "q-chip",
                                  { attrs: { small: "", color: "negative" } },
                                  [
                                    _vm._v(
                                      "\n                Muted until\n                " +
                                        _vm._s(
                                          _vm
                                            .moment(_vm.agent.muted_until)
                                            .format("MM/DD/YY h:mmA")
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.agent.admin_notes
                          ? _c("div", [
                              _c("span", { staticClass: "q-card-title" }, [
                                _vm._v("Admin notes")
                              ]),
                              _c("p", {
                                staticClass: "pre-line",
                                domProps: {
                                  innerHTML: _vm._s(_vm.agent.admin_notes)
                                }
                              })
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "q-mt-sm" },
                          [
                            _vm.agent.stripe != null
                              ? _c("q-btn", {
                                  attrs: {
                                    size: "sm",
                                    rounded: "",
                                    color: "blue",
                                    outline: "",
                                    icon: "fab fa-cc-stripe",
                                    label: "Payment Dashboard",
                                    "no-caps": ""
                                  },
                                  on: { click: _vm.openStripeAcc }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "q-mt-sm" },
                          [
                            !_vm.agent.verified
                              ? _c("q-btn", {
                                  attrs: {
                                    disable: _vm.disabled,
                                    size: "sm",
                                    rounded: "",
                                    outline: "",
                                    color: "positive",
                                    icon: "mail",
                                    "no-caps": "",
                                    label: "Resend Invite"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.sendVerificationEmail($event)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "q-mt-sm" },
                          [
                            _c("q-btn", {
                              attrs: {
                                size: "sm",
                                rounded: "",
                                outline: "",
                                color: "blue",
                                "no-caps": "",
                                label: "Edit Agent"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.openEditModal($event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "q-mt-sm" },
                          [
                            _c("q-btn", {
                              attrs: {
                                disable: _vm.disabled,
                                size: "sm",
                                rounded: "",
                                color: _vm.agent.blocked ? "green" : "red",
                                outline: "",
                                label: _vm.agent.blocked
                                  ? "Unblock Agent"
                                  : "Block Agent",
                                "no-caps": ""
                              },
                              on: { click: _vm.blockAgent }
                            })
                          ],
                          1
                        ),
                        !_vm.agent.is_showami
                          ? _c(
                              "div",
                              { staticClass: "q-mt-sm" },
                              [
                                _c("q-btn", {
                                  attrs: {
                                    size: "sm",
                                    rounded: "",
                                    outline: "",
                                    color: "positive",
                                    label: "Send push notification",
                                    "no-caps": ""
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.sendNotificationModal.visible = true
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.agent.is_showami &&
                        (_vm.agent.is_mimo_inspection_capable ||
                          _vm.agent.is_periodic_inspection_capable ||
                          _vm.agent.is_vacancy_check_inspection_capable)
                          ? _c(
                              "div",
                              { staticClass: "q-mt-sm" },
                              [
                                _c("q-btn", {
                                  attrs: {
                                    disable: _vm.disabled,
                                    size: "sm",
                                    rounded: "",
                                    outline: "",
                                    color: "positive",
                                    label:
                                      "Send inspection briefing for tomorrow",
                                    "no-caps": ""
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.sendInspectionsBriefing()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 col-xs-12" },
            [
              _c(
                "q-card",
                [
                  _c(
                    "q-card-title",
                    [
                      _vm._v("\n        Earnings\n        "),
                      _c(
                        "q-chip",
                        { attrs: { slot: "right" }, slot: "right" },
                        [
                          _vm._v(
                            "\n          $" +
                              _vm._s(_vm.agent.transactions_sum) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 col-xs-12" },
            [
              _c(
                "q-card",
                [
                  _c(
                    "q-card-title",
                    [
                      _vm._v("\n        Last 7 days Earnings\n        "),
                      _c(
                        "q-chip",
                        { attrs: { slot: "right" }, slot: "right" },
                        [
                          _vm._v(
                            "\n          $" +
                              _vm._s(_vm.agent.last_week_transactions_sum) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 col-xs-12" },
            [
              _c(
                "q-card",
                [
                  _c(
                    "q-card-title",
                    [
                      _vm._v("\n        Tours count\n        "),
                      _c(
                        "q-chip",
                        { attrs: { slot: "right" }, slot: "right" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.agent.tours_count) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 col-xs-12" },
            [
              _c(
                "q-card",
                [
                  _c(
                    "q-card-title",
                    [
                      _vm._v("\n        Last 7 days tours count\n        "),
                      _c(
                        "q-chip",
                        { attrs: { slot: "right" }, slot: "right" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.agent.last_week_tours_count) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 col-xs-12" },
            [
              _c(
                "q-card",
                [
                  _c(
                    "q-card-title",
                    [
                      _c(
                        "router-link",
                        {
                          directives: [{ name: "tippy", rawName: "v-tippy" }],
                          attrs: {
                            to: {
                              name: "app.inspections",
                              query: { "agents[]": _vm.agent.id }
                            },
                            title: "View agent's inspections"
                          }
                        },
                        [_vm._v("\n          Inspections\n        ")]
                      ),
                      _vm._v(" count\n        "),
                      _c(
                        "q-chip",
                        { attrs: { slot: "right" }, slot: "right" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.agent.inspections_count) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("bj-tours-data-table", {
                attrs: {
                  "with-header": false,
                  "with-agent-filter": false,
                  "filter-by-agent-id": _vm.agent.id
                }
              })
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }